// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .skeleton-content {
  display: flex;
  flex-flow: column nowrap;
  row-gap: 10px;
  margin-top: 0;
}
:host .skeleton-content .product-card-skeleton {
  width: 100%;
  height: 135px;
  margin: 0;
  --border-radius: var(--radius-xl);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-treatment/skeleton-treatment.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,wBAAA;EACA,aAAA;EACA,aAAA;AAAR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,iCAAA;AAAZ","sourcesContent":[":host {\r\n    .skeleton-content {\r\n        display: flex;\r\n        flex-flow: column nowrap;\r\n        row-gap: 10px;\r\n        margin-top: 0;\r\n\r\n        .product-card-skeleton {\r\n            width: 100%;\r\n            height: 135px;\r\n            margin: 0;\r\n            --border-radius: var(--radius-xl);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
